import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import RadioButton from '@bibliocommons/base-radio-button';
import { routerShape } from '@bibliocommons/bc-prop-types';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';

import { scopeShape } from 'app/shapes/search';

import './SearchScopeField.scss';

export class SearchScopeField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderScopeLink(scope) {
    const { router } = this.props;

    const scopeId = scope.get('scopeId');
    const isApplied = this.props.currentSearchScope === scopeId;
    const inputId = uniqueId(`Scope_${scope.get('scopeId')}_`);
    const label = scope.get('scopeName');
    const radioGroupName = uniqueId('searchScopes_');

    const handleChange = () => {
      const query = {
        ...router.query,
        searchScope: scopeId,
        lastSearchScope: router.query.searchScope
      };

      router.push({ query });
    };

    return (
      <li className="filter" key={inputId}>
        <RadioButton checked={isApplied} handleChange={handleChange} id={inputId} label={label} name={radioGroupName} />
      </li>
    );
  }

  render() {
    return (
      <section className="cp-search-scope-field">
        <FormattedMessage id="section_title_show_results_at">
          {message => <h4 className="field-name">{message}</h4>}
        </FormattedMessage>
        <ul className="filter-list">{this.props.scopes.map(this.renderScopeLink)}</ul>
      </section>
    );
  }
}

SearchScopeField.displayName = 'SearchScopeField';
SearchScopeField.propTypes = {
  currentSearchScope: PropTypes.string.isRequired,
  router: routerShape,
  scopes: ImmutablePropTypes.listOf(scopeShape).isRequired
};

export default withRouter(SearchScopeField);
